import React from 'react';
import { Check } from 'lucide-react';

function StepIndicator({ current, labels }) {
  return (
    <div className="step-indicator">
      {labels.map((label, i) => {
        const step = i + 1;
        const state = step < current ? 'done' : step === current ? 'active' : 'upcoming';
        return (
          <React.Fragment key={label}>
            <div className={`step-node ${state}`}>
              <span className="step-circle">{state === 'done' ? <Check size={16} strokeWidth={2.5} /> : step}</span>
              <span className="step-label">{label}</span>
            </div>
            {step < labels.length && <span className={`step-line ${state === 'done' ? 'done' : ''}`}></span>}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default StepIndicator;
